export default {
  projectid: "0123456789",
  projectname: "projectname",
  datestring: ""   
}